const firebaseConfig = {
    apiKey: "AIzaSyCvKHwpo25Zv21VG0SHQKBeF2fojCZmTA8",
    authDomain: "travel-52c95.firebaseapp.com",
    projectId: "travel-52c95",
    storageBucket: "travel-52c95.appspot.com",
    messagingSenderId: "216327679758",
    appId: "1:216327679758:web:31c1bf94f3b7e49ebf315f"
};

export default firebaseConfig;